import { PUBLIC_OFFERS } from 'constants/api';
import client from 'requests';

export interface ISubscriptionUser {
  id: number;
  phone_number?: string;
  users_basic_info?: {
    id: string;
    email?: string;
    name: string;
    surname?: string;
  };
}

export interface IOffer {
  id: string;
  name: string;
  code: string;
  status: string;
  start_date: string;
  close_date: string;
  currency: string;
}

export interface ISubscriptionTransaction {
  id: string;
  api_consumer_id?: number;
  currency?: string;
  exchange_rate?: string;
  fee?: string;
  number_of_shares?: number;
  offer_id?: string;
  payment_channel_id?: number;
  price_per_share?: string;
  reference?: string;
  user_id?: number;
  inserted_at: string;
  updated_at?: string;
  offer_name: string;
  type: string;
  total_amount: string;
  status: string;
  chn: string | null;
  cscs_no: string | null;
  broker_id: string | null;
  broker_name: string | null;
  rin?: string | null;
}

export interface ISubscription {
  id: string;
  offer_id: string;
  api_consumer_id: number;
  average_cost: string;
  number_of_shares: string;
  total_number_of_shares?: string;
  total_amount_subscribed?: string | number;
  offer_name: string;
  user_id: string;
  allocated_shares: number | string | null;
  certificate_no: string | null;
  inserted_at: string;
  updated_at: string;
  user?: ISubscriptionUser;
  offer?: IOffer;
  orders?: ISubscriptionTransaction[];
}

export interface ISubscriptionQuery {
  page?: number;
  limit?: number;
  q?: string;
  start_date?: number;
  end_date?: number;
}

const getSubscriptions = (params: ISubscriptionQuery, signal?: AbortSignal) =>
  client.get<IPaginatedEndpointResp<ISubscription>>(PUBLIC_OFFERS.GET_PORTFOLIOS, {
    params,
    signal
  });

const getSubscription = (id: string, signal?: AbortSignal) =>
  client.get<ISubscription>(PUBLIC_OFFERS.GET_PORTFOLIO.replace(':id', id), { signal });

const getUserSubscriptions = (userId: string, signal?: AbortSignal) =>
  client.get<ISubscription[]>(PUBLIC_OFFERS.GET_USER_PORTFOLIOS.replace(':user_id', userId), {
    signal
  });

export default getSubscriptions;
export { getSubscription, getUserSubscriptions };
